var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from "react";
import styled from "../../themes/styled";
import Box from "../../box/Box";
import IndexIcon from "../../shared/IndexIcon";
import { useSpring, animated, interpolate } from "react-spring/web.cjs";
import { useDrag } from "@use-gesture/react";
var Container = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-rows: min-content 1fr;\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        .hide-ie {\n            display: none !important;\n        }\n    }\n"], ["\n    position: relative;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-rows: min-content 1fr;\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        .hide-ie {\n            display: none !important;\n        }\n    }\n"])));
var Showcase = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    grid-row: 1 / span 1;\n    grid-column: 1 / -1;\n    overflow: hidden;\n"], ["\n    grid-row: 1 / span 1;\n    grid-column: 1 / -1;\n    overflow: hidden;\n"])));
var MediaList = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    touch-action: pan-x;\n    position: relative;\n    display: grid;\n    grid-auto-columns: 100%;\n    backface-visibility: hidden;\n    z-index: 1;\n    .dashContainer {\n        display: none;\n    }\n"], ["\n    touch-action: pan-x;\n    position: relative;\n    display: grid;\n    grid-auto-columns: 100%;\n    backface-visibility: hidden;\n    z-index: 1;\n    .dashContainer {\n        display: none;\n    }\n"])));
var AnimatedMediaList = animated(MediaList);
export var Mobile = function (_a) {
    var currentIndex = _a.currentIndex, updateIndex = _a.updateIndex, incrementIndex = _a.incrementIndex, decrementIndex = _a.decrementIndex, children = _a.children, rest = __rest(_a, ["currentIndex", "updateIndex", "incrementIndex", "decrementIndex", "children"]);
    var minIndex = 1;
    var maxIndex = React.Children.count(children) - 1;
    var firstRender = useRef(true);
    var _b = useSpring(function () { return ({
        translateX: 0,
        dragX: 0
    }); }), _c = _b[0], translateX = _c.translateX, dragX = _c.dragX, set = _b[1];
    var bind = useDrag(function (_a) {
        var movement = _a.movement, last = _a.last, velocity = _a.velocity, xDir = _a.direction[0];
        var DRAG_THRESHOLD = Math.floor(window.innerWidth / 3);
        var x = movement[0];
        var vx = velocity[0];
        set({ dragX: x, immediate: true });
        if (last) {
            var shouldTransition = Math.abs(x) >= DRAG_THRESHOLD;
            if (!shouldTransition) {
                set({ dragX: 0, immediate: false });
            }
            else {
                var nextPosition = void 0;
                if (x > DRAG_THRESHOLD) {
                    var clampedMax = Math.min(maxIndex, currentIndex + 1);
                    nextPosition = clampedMax * -100 + 100;
                    incrementIndex();
                }
                if (x < DRAG_THRESHOLD) {
                    var clampedMin = Math.max(minIndex, currentIndex - 1);
                    nextPosition = clampedMin * -100 - 100;
                    decrementIndex();
                }
                set({
                    dragX: 0,
                    translateX: nextPosition,
                    immediate: false,
                    config: {
                        velocity: vx
                    }
                });
            }
        }
    });
    useEffect(function () {
        set({ translateX: currentIndex * 100 * -1, immediate: firstRender.current });
        firstRender.current = false;
    }, [currentIndex, set]);
    return (React.createElement(Container, __assign({}, rest),
        React.createElement(Showcase, null,
            React.createElement(AnimatedMediaList, __assign({}, bind(), { style: {
                    transform: interpolate([
                        translateX,
                        dragX
                    ], function (translateX, dragX) { return "translateX(calc(".concat(translateX, "% + ").concat(dragX, "px))"); })
                } }), React.Children.map(children, function (child, i) { return (React.createElement(Box, { key: i, gridColumn: i + 1 }, child)); }))),
        React.createElement(Box, { className: "hide-ie", gridColumn: ["1 / -1", "1 / -1", "2 / span 10"], gridRow: "2", ml: [0, 0, "40%"], display: ["flex", "flex", "block"], px: 6, justifyContent: "center" }, React.Children.map(children, function (child, i) { return (React.createElement(IndexIcon, { key: i, active: i === currentIndex, onClick: function () {
                updateIndex(i);
            }, style: { cursor: "pointer" } })); }))));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Mobile.js.map